import {
  Nav,
  NavMenu,
  NavBtn,
  NavLink
  } from './NavbarElements';

import LogoutLoginButton from "./LogoutLoginButton"
import { SidedrawerProducer } from "./SidedrawerElements"
import { useAuthenticator } from '@aws-amplify/ui-react';
import logo from "../../assets/images/merum.jpg";
const LoginNavbar = () => {

  const { route } = useAuthenticator((context) => [context.route]);

	return (
    <>
      <Nav>
      <NavMenu>
        {route === "authenticated" ? (
          <SidedrawerProducer/>
        ) : ''}
        <NavLink to='/home'>
          <img
            alt=""
            src={logo}
            id="logoimg" 
            width={"100px"}
          />
        </NavLink>
      </NavMenu>
      
      <NavMenu>
      </NavMenu>
      <NavBtn>
      <LogoutLoginButton />
      </NavBtn>
      {/* <MenuNavigation></MenuNavigation> */}
    </Nav>
    </>
  );
};

export default LoginNavbar;